import {
  Component,
  OnInit,
  HostListener,
  Input,
  ViewChild,
  ElementRef,
  Inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OwlOptions, CarouselComponent } from 'ngx-owl-carousel-o';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { Location } from '@angular/common';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-marketplace-bottom-banner',
  templateUrl: './marketplace-bottom-banner.component.html',
  styleUrls: ['./marketplace-bottom-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarketplaceBottomBannerComponent implements OnInit {
  @ViewChild('selectRelateArticle') selectRelateArticle!: ElementRef;

  @Input() showBody: boolean = true;
  @Input() selectedHashtag: any = '';
  @ViewChild('owlElement') owlElement: CarouselComponent;
  @ViewChild('detailBlog') detailBlog: ElementRef;
  @Input() shop_template: string = 'default';

  get_bottom_banner_response: any = [{ image: '' }];
  get_bottom_banner_response_latest: any = [];
  imgUrl = environment.ImageUrl;
  client_id: any = 0;
  get_bottom_banner_response_length: any = 0;
  encrypted_client_id: string = '';
  enc_app_user_id: string = '';
  isMarketplace: boolean = false;
  detail: any = {};
  baseUrlImage = environment.ImageUrl;
  isLogin: any = 0;
  appUserId: any = 0;

  bottomImagesForm: FormGroup;
  // Editor = ClassicEditor;
  EditorData: any = ``;
  EditorConfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        // 'insertTable',
        'imageUpload',
        '|',
        'undo',
        'redo',
      ],
    },
  };
  ckEditorText: string = '';

  blogImageUrl: string = '';
  blogPathImage: any = null;
  blogImageSelected: any = null;
  categories: any = [
    'SG News',
    'Promotions',
    'Funny',
    'Business',
    'Food',
    'TGIF',
    'Self-Enlightenment',
    'Home Improvement',
  ];
  categoryIconMap = {
    'SG News': 'newspaper',
    Promotions: 'rectangle-ad',
    Funny: 'music',
    Business: 'business-time',
    Food: 'utensils',
    TGIF: 'shopping-cart',
    'Self-Enlightenment': 'shopping-cart',
    'Home Improvement': 'shopping-cart',
  };
  category: string = this.categories[0];
  isPopular: boolean = true;
  private modalRef: any;
  carouselOptions: any = {
    slidesPerView: 'auto',
    pagination: false,
  };

  selectedArticleRelate: any = {};
  listArticlesRelated: any = [];
  bottomBannerTarget: any = null;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private fb: FormBuilder,
    private sharedService: SharedService,
    private location: Location,
    private commonService: CommonService,
    @Inject("WINDOW") private window: any,
  ) {
    this.route.params.subscribe((res: any) => {
      if (Object.keys(res).length === 0) {
        return;
      }
      if (res.id) {
        const originalText = res.id.trim();
        const splitText = originalText.split('_');
        if (splitText.length == 2 && splitText.includes('normal')) {

          this.client_id = splitText[1];
          this.encrypted_client_id = encodeURIComponent(res.id.trim());
        } else if (splitText.length == 3 && splitText.includes('referral')) {

          this.client_id = splitText[1];
          this.enc_app_user_id = splitText[2];
          this.encrypted_client_id = encodeURIComponent(res.id.trim());
        } else {
        }
      }
    });
  }

  ngOnChanges(changes: any) {
    const value = changes?.selectedHashtag?.currentValue;
    this.get_bottom_banner(1, value == 'All' ? '' : value);
  }

  goBack() {
    this.commonService.goBack();
  }
  defaultOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: false,
    navSpeed: 700,
    smartSpeed: 4500,
    autoplayHoverPause: true,
    slideTransition: 'linear',
    navText: [
      '<i id="prev-btn" class="prev-btn"></i>',
      '<i id="next-btn" class="next-btn"></i>',
    ],
    items: 3,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 3,
      },
      // 940: {
      //   items: 4,
      // },
    },
    nav: true,
  };

  mobileOptions: OwlOptions = {
    ...this.defaultOptions,
    nav: false,
    dots: true,
  };
  banners: any = {};

  customOptions: OwlOptions = this.defaultOptions;

  ngOnInit(): void {
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.appUserId = user.id;
        this.isLogin = 1;
      } else {
        this.isLogin = 0;
      }
    });
    let checkUrl = '';
    if (this.sharedService.isBrowser()) {
      checkUrl = this.window.location.href;
    }
    if (checkUrl.includes('biz')) {
      this.isMarketplace = true;
    }
    this.get_bottom_banner();
    this.updateOwlOptions();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateOwlOptions();
  }

  updateOwlOptions() {
    if (this.sharedService.isBrowser()) {
      if (this.window.innerWidth < 600) {
        this.customOptions = this.mobileOptions;
      } else {
        this.customOptions = this.defaultOptions;
      }
    }
  }
  getPages = () =>
    this.local.getPages(this.banners.currentPage, this.banners.lastPage);

  get_bottom_banner(page = 1, hashtag = '') {
    const clientId = this.client_id;
    this.auth
      .get_bottom_banner({
        adminId: clientId,
        isAdmin: this.isMarketplace,
        page: page,
        isPopular: this.isPopular ? 1 : 0,
        category: this.category,
        hashtag: hashtag
      })
      .subscribe(
        (response: any) => {
          if (response.body && Array.isArray(response.body.data)) {
            this.banners = response.body;
            this.get_bottom_banner_response = response.body.data;
            this.get_bottom_banner_response_length = response.body.data.length;
            this.get_bottom_banner_response_latest = response.body.data;
          }
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }

  convertDate(value: number) {
    let date = value;

    return moment.unix(value).format('MMMM D, YYYY');
  }

  checkShopAndEmpty() {
    return (
      this.window.location.href.includes('/mobile/') &&
      this.get_bottom_banner_response_length < 1
    );
  }

  navigateToUrl(url: string): void {
    this.window.open(url, '_blank');
  }

  openDetailBlog(modal: any, item: any) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(this.detailBlog, {
      size: 'md',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-blog',
    });

    this.detail = item;
  }

  onEditorChange(event: any) {
    // this.ckEditorText = event.editor.getData();
  }

  openModalBlogForm(modal: any, item: any = { text: '' }) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
    });

    this.ckEditorText = item?.text;
    this.blogImageUrl =
      item?.image != null ? `${this.baseUrlImage}${item.image}` : '';
    this.bottomImagesForm = this.fb.group({
      id: [item?.id, []],
      banner: ['', [Validators.required]],
      title: [item?.title, [Validators.required]],
      author: [item?.author, [Validators.required]],
      category: [item?.category, [Validators.required]],
    });
  }

  timeout1: any;
  openModalRelate(modal: any, item: any = {}) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
    });

    this.selectedArticleRelate = item;
    const articleIdList = [];
    for (let row of item.related) {
      if (row.bottomBannerId != item.id) {
        articleIdList.push(row.bottomBannerId);
      }
      if (row.bottomBannerTarget != item.id) {
        articleIdList.push(row.bottomBannerTarget);
      }
    }
    this.auth
      .get_bottom_banner_for_related_by_id({
        articleIdList: JSON.stringify(articleIdList),
      })
      .subscribe((resp: any) => {
        this.selectedArticleRelate.related = resp?.body;
      });
    this.listArticlesRelated = this.banners.data.filter(
      (row: any) => row.id != item.id
    );
    this.local.clearTimeout(this.timeout1)
    this.timeout1 = setTimeout(() => {
      this.initializeSelect2();
    }, 500);
  }

  editBlog(modal: any, item: any) {
    this.openModalBlogForm(modal, item);
  }

  onBottomBannerSelected(files: any, event: any) {
    this.blogImageUrl = '';
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0]?.type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    const file = event.target.files;
    if (file && file[0]) {
      if (file[0].size > 2097152) {
        this.toastr.error('Max File size must be Less than 2MB!');
        return;
      }

      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.blogImageUrl = event.target.result;
      };
      reader.readAsDataURL(file[0]);
    }

    this.blogPathImage = files;
    this.blogImageSelected = <File>files[0];
  }

  addBottomBanner() {
    // alert()
    // this.submitted = true;

    const id = this.bottomImagesForm.value.id;

    if (this.bottomImagesForm.invalid && id == null) {
      this.toastr.error('Please fill all forms !');
      return;
    }

    let formData = new FormData();
    formData.append('title', this.bottomImagesForm.value.title);
    formData.append('category', this.bottomImagesForm.value.category);
    formData.append('text', this.ckEditorText);
    // formData.append('url', this.bottomImagesForm.value.url);
    formData.append('author', this.bottomImagesForm.value.author);
    formData.append('image', this.blogImageSelected);
    formData.append('adminId', '0');
    formData.append('isAdmin', '1');

    let method = 'add_bottom_banner';
    if (id != null) {
      method = 'edit_bottom_banner';
      formData.append('bottomBannerId', id);
    }

    this.local.alertLoading({});

    this.auth[method](formData).subscribe(
      (response: any) => {
        Swal.close();

        this.modalService.dismissAll();
        this.get_bottom_banner();
        // this.bottom_banner_image_url_show = 0;
        this.toastr.success(response.message);
      },
      (e) => {
        this.toastr.error(e.error.message);
        Swal.close();
      }
    );
  }
  addBottomBannerRelate() {
    if (this.addBottomBannerRelate == null) {
      this.toastr.error('Please fill all forms !');
      return;
    }

    let formData = new FormData();
    formData.append('bottomBannerId', this.selectedArticleRelate.id);
    formData.append('bottomBannerTarget', this.bottomBannerTarget);

    this.local.alertLoading({});

    this.auth.related_bottom_banner(formData).subscribe(
      (response: any) => {
        Swal.close();

        this.modalService.dismissAll();
        this.get_bottom_banner();
        // this.bottom_banner_image_url_show = 0;
        this.toastr.success(response.message);
      },
      (e) => {
        this.toastr.error(e.error.message);
        Swal.close();
      }
    );
  }

  deleteBlog(id: number) {
    this.local.alertConfirm({}).then((resp: any) => {
      if (resp.isConfirmed) {
        this.auth.delete_bottom_banner({ bottomBannerId: id }).subscribe(
          (response: any) => {
            this.modalService.dismissAll();
            this.get_bottom_banner();
            // this.bottom_banner_image_url_show = 0;
            this.toastr.success(response.message);
          },
          (e) => {
            this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  hasChecked(data: any) {
    return data.filter((row: any) => row.userId == this.appUserId).length > 0;
  }

  likeHandle(bottomBannerId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    const payload = {
      userId: this.appUserId,
      bottomBannerId: bottomBannerId,
    };

    if (this.hasChecked(data.bottomBannerLikes))
      data.bottomBannerLikes = data.bottomBannerLikes.filter(
        (row: any) => row.userId != this.appUserId
      );
    else data.bottomBannerLikes = [...data.bottomBannerLikes, payload];

    this.auth.likes_bottom_banner(payload).subscribe(() => {
      this.get_bottom_banner();
    });
  }

  filterByCategory(value: string) {
    this.category = value;
    this.get_bottom_banner();
  }

  prev() {
    const nextButton = document.querySelector('.prev-btn') as HTMLElement;
    if (nextButton) {
      nextButton.click();
    }
  }

  next() {
    const nextButton = document.querySelector('.next-btn') as HTMLElement;
    if (nextButton) {
      nextButton.click();
    }
  }

  //   function dateDifference(dateString) {
  //     // Parse the input date string
  //     const inputDate = new Date(dateString);
  //     const currentDate = new Date();

  //     // Calculate the difference in time (milliseconds)
  //     const timeDifference = currentDate - inputDate;

  //     // Calculate the difference in days
  //     let daysDifference = currentDate.getDate() - inputDate.getDate();
  //     let monthsDifference = currentDate.getMonth() - inputDate.getMonth();
  //     const yearsDifference = currentDate.getFullYear() - inputDate.getFullYear();

  //     // If days difference is negative, adjust months and days
  //     if (daysDifference < 0) {
  //         monthsDifference--;
  //         const previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
  //         daysDifference += previousMonth;
  //     }

  //     // If months difference is negative, adjust years and months
  //     if (monthsDifference < 0) {
  //         monthsDifference += 12;
  //     }

  //     // Add the year difference to the months
  //     monthsDifference += yearsDifference * 12;

  //     return { days: daysDifference, months: monthsDifference };
  // }
  removeHtmlTags(text: string): string {
    return text ? text.replace(/<[^>]*>/g, '') : '';
  }
  formatText(text: string, length): string {
    const cleanText = this.removeHtmlTags(text);
    return cleanText.length > length
      ? cleanText.substr(0, length) + '...'
      : cleanText;
  }

  public diamond: number = 0;

  public addDiamonds(modal, article) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
    });
    this.selectedArticleRelate = article;
  }

  public submitAddDiamonds() {
    this.auth
      .addNewsDiamond({
        newsId: this.selectedArticleRelate.id,
        diamonds: this.diamond,
        type: 'DIAMONDS-ADD',
      })
      .subscribe(
        (response: any) => {
          this.modalService.dismissAll();
          this.toastr.success(response.message);
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }

  initializeSelect2() {
    const selectElement = document.getElementById("selectRelateArticle");

    // Initialize Select2
    // selectElement
    //   .select2({
    //     ajax: {
    //       url: environment.baseUrlAdmin + 'get_bottom_banner_for_related', // Replace with your API endpoint
    //       dataType: 'json',
    //       delay: 250,
    //       data: (params: any) => {
    //         return {
    //           q: params.term, // search term,
    //           exceptId: this.selectedArticleRelate.id,
    //         };
    //       },
    //       processResults: (data: any) => {
    //         return {
    //           results: data.body.map((item: any) => {
    //             return {
    //               id: item.id,
    //               text: `${item.title} ${item.related > 0 ? '+' + item.related : ''
    //                 }`,
    //             };
    //           }),
    //         };
    //       },
    //       cache: true,
    //     },
    //     minimumInputLength: 1,
    //     placeholder: 'Select Article',
    //   })
    //   .on('select2:select', (e: any) => {
    //     this.bottomBannerTarget = e.params.data.id;
    //   });
  }

  handleDeleteRelatedArticle(item: any) {
    this.local
      .alertConfirm({
        message: `Are you sure want to delete ${item.title} as Related Article ?`,
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.local.alertLoading({});
          this.auth
            .delete_bottom_banner_for_related_by_id({
              bottomBannerId: this.selectedArticleRelate.id,
              bottomBannerTarget: item.id,
            })
            .subscribe(
              (resp) => {
                this.toastr.success('SUCCESS');
                this.selectedArticleRelate.related =
                  this.selectedArticleRelate.related.filter(
                    (row: any) => row.id != item.id
                  );
                Swal.close();
              },
              (e) => {
                this.toastr.error('FAILED');
                Swal.close();
              }
            );
        }
      });
  }

  // handleDeleteOwnArticle(item: any) {
  //   this.local.alertConfirm({
  //     message: `Are you sure want to delete ${item.title}?`
  //   }).then((resp) => {
  //     if (resp.isConfirmed) {
  //       this.local.alertLoading({})
  //       this.auth.delete_bottom_banner({
  //         bottomBannerId: item.id,
  //       }).subscribe((resp) => {
  //         this.toastr.success("SUCCESS")
  //         this.get_bottom_banner();
  //         Swal.close()
  //       }, (e) => {
  //         this.toastr.error("FAILED")
  //         Swal.close()
  //       })
  //     }
  //   })
  // }
}
